import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useTranslations, useFeedbackModel } from "examsbook-react-sdk/custom-hooks";
import FeedbackModel from "./Feedback/FeedbackModel";

const QuestionErrors = [
    'wrong_question',
    'wrong_answer',
    'formatting_issue',
    'other_problem'
];

const ITEM_HEIGHT = 48;

function LongMenu(props) {
    const [ anchorEl, setAnchorEl ] = useState();
    const { question } = props;
    const t = useTranslations();

    const {
        isFeedbackModelOpen,
        openFeedbackModel,
        reportErrorFn,
        closeFeedBackModel
    } = useFeedbackModel();

    function openMenu(event) {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    }

    function closeMenu(event) {
        event.stopPropagation();
        setAnchorEl(null);
    }

    function reportError(errorMsg, event) {
        const errorData = {
            title: question.title,
            questionId: question._id,
            message: errorMsg
        };
        openFeedbackModel(errorData);
        closeMenu(event);
    }

    const open = Boolean(anchorEl);
    return (
        <div>
            <IconButton
                aria-label="More"
                aria-owns={open ? 'long-menu' : undefined}
                aria-haspopup="true"
                onClick={openMenu}
            >
                <MoreVertIcon/>
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={closeMenu}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: 200,
                    },
                }}
            >
                {QuestionErrors.map(option => (
                    <MenuItem key={option} selected={option === 'Pyxis'}
                              onClick={(event) => reportError(t(option), event)}>
                        {t(option)}
                    </MenuItem>
                ))}
            </Menu>
            {
                isFeedbackModelOpen ? <FeedbackModel
                    isFeedbackModelOpen={isFeedbackModelOpen}
                    closeFeedBackModel={closeFeedBackModel}
                    submitForm={reportErrorFn}/> : ''
            }
        </div>
    );
}

export default LongMenu;
